import { Grid } from '@mui/material';
import { DateTime } from 'luxon';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Button,Dimmer, Icon, Loader, Segment, Image } from 'semantic-ui-react';
import { appInsights } from '../../AppInsights';
import styles from './DocumentView.module.scss';
import loaderImage from '../../assets/img/short-paragraph.png';
import { Providers } from '@microsoft/mgt-element';
import { ISearch, IUrlVariables } from '../../intefaces';
import { DataService, Helper, IDataService, IHelper } from '../../services';
import { DocumenthOcr, DocumentEdit } from '../../components';
import { saveAs } from 'file-saver';



interface ISearchProps {
    q: any;
}

interface ISearchState {
    searchText: string;
    redirect: boolean;
    id: string;
    author: string;
    title: string;
    titleArray: string[],
    division: string;
    contractDate: string;
    agency: string;
    documentType: string[];
    securityGroup: string;
    counterparties: string;
    counterparties2: string;
    hOCRMetadata: string;
    isLoading: boolean;
    error: boolean;
    noAccess: boolean;
    logged: boolean;
    fileName: string;
    fullFileName: string;
}

class DocumentView extends React.Component<ISearchProps, ISearchState> {
    private _helpers: IHelper = new Helper();
    private _dataService: IDataService = new DataService();

    constructor(props: any) {
        super(props);
        this.state = {
            searchText: '',
            redirect: false,
            id: '',
            author: '',
            title: '',
            titleArray: [],
            division: '',
            contractDate: '',
            agency: '',
            documentType: [],
            securityGroup: '',
            counterparties: '',
            counterparties2: '',
            hOCRMetadata: '',
            isLoading: true,
            error: false,
            noAccess: true,
            logged: false,
            fileName: '',
            fullFileName: ''
        }
    }

    async componentDidMount() {
        window.history.pushState(null, 'DocumentView', window.location.pathname + this.props.q);
        this.getSearchDetails().then(async () => {
            await this.getApi(this.state.id).then(() => {
                this.setState({ isLoading: false });
                let provider = Providers.globalProvider;
                if (provider.state == 2) {
                    this.setState({ logged: true });
                }
            });
        });
    }

    public async componentDidUpdate(prevProps: ISearchProps, prevState: ISearchState) {
        if (prevState.id != this.state.id) {
            this.setState({ isLoading: true });
            await this.getApi(this.state.id).then(() => {
                this.setState({ isLoading: false });
                let provider = Providers.globalProvider;
                if (provider.state == 2) {
                    this.setState({ logged: true });
                }
            });
        }
    }

    public render() {
        appInsights.trackPageView({
            uri: window.location.href + this.props.q,
            name: 'Document View'
        });
        const fuzzy = localStorage.getItem('fuzzySearch') || 'true';
        const searchQuery = `/search?q=${this.state.searchText}&fuzzy=${fuzzy}`;

        return (
            <div className={styles.searchReultsPage}>
                <div className={styles.mainBody}>
                    {this.state.redirect && <Redirect to={searchQuery} />}
                    {this.state.isLoading && <Segment><Dimmer active inverted><Loader>Loading contract</Loader></Dimmer><Image src={loaderImage} /></Segment>}
                    {this.state.error && !this.state.isLoading && !this.state.logged && <div className={styles.errorMessage}>You have reached an unexpected error, use the back button on your browser to return to the previous page and try again.</div>}
                    {!this.state.logged && !this.state.isLoading && <div className={styles.errorMessage}>You are currently not logged in, back to Home and use the "Sign in" button on the top right of the screen to sign in using your Hachette AD credentials.<br /><br /> <a href='/'><Icon name='home' />Home</a></div>}
                    {this.state.noAccess && !this.state.isLoading && this.state.logged && <div className={styles.errorMessage}> You don't have access to this document </div>}

                    {!this.state.isLoading && !this.state.error && this.state.logged && 
                            <button onClick={(e) => this.clickHandle(e)} className={styles.perviousBtn} >
                                <Icon name='angle left' />
                                <span>Back to results</span>
                            </button>
                    }
                    <div>
                    {!this.state.isLoading && !this.state.error && this.state.logged &&
                    this.showDownloadButton()                         
                    }
                    </div>
                    {!this.state.isLoading && !this.state.error && this.state.logged && !this.state.noAccess &&
                    <>
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <div className={styles.title}>{this.state.title}</div>
                                    <div className={styles.authordate}>{this.state.author}   |    {this.state.contractDate}</div>
                                </Grid>
                                <Grid item xs={6}>
                                    {this.showEditButton()}
                                </Grid>
                            </Grid>
                            <DocumenthOcr hOcrString={this.state.hOCRMetadata} title={this.state.title} />
                        </>}
                </div>
                <footer>
                </footer>

            </div>
        )
    }

    private showEditButton() {
        let directory = localStorage.getItem('securityGroup') || '';
        if (directory !== '' && process.env.REACT_APP_EDITORS != undefined) {
            let a = directory.match(process.env.REACT_APP_EDITORS || '');
            if (a != undefined) {
                if (a.length > 0) {
                    return <DocumentEdit id={this.state.id} searchText={this.state.searchText}
                        agency={this.state.agency} author={this.state.author} contractDate={this.state.contractDate}
                        counterparties={this.state.counterparties} counterparties2={this.state.counterparties2}
                        division={this.state.division} documentType={this.state.documentType} title={this.state.titleArray} className={styles.editDoc}
                        updated={(e: boolean) => this.documentUpdated(e)}
                        deleted={(e: boolean) => this.documentDeleted(e)}
                    />
                }
            }
        }
    }

    private showDownloadButton() {
        let directory = localStorage.getItem('securityGroup') || '';
        if (directory !== '' && process.env.REACT_APP_DOWNLOADERS != undefined) {
            let a = directory.match(process.env.REACT_APP_DOWNLOADERS || '');
            if (a != undefined) {
                if (a.length > 0) {
                    return (
                        <Button
                        content='Download'
                        floated='right'
                        onClick={(e) => this.downloadDocument(e)}
                    />
                    )
                }
            }
        }
    }

    private documentDeleted(e: boolean) {
        if (e == true) {
            this.setState({ redirect: true });
        }
    }

    private documentUpdated(e: boolean) {
        if (e == true) {
            this.setState({ isLoading: true });
            this.getSearchDetails().then(async () => {
                await this.getApi(this.state.id).then(() => {
                    this.setState({ isLoading: false });
                });
            });
        }
    }

    private clickHandle(event: any) {
        appInsights.trackEvent({ name: 'search results' }, { key: 'back to search results' });
    
        const savedState = sessionStorage.getItem("searchState");
    
        // let searchQuery = "/search";
        if (savedState) {
            sessionStorage.setItem("fromResults", "true"); 
            const state = JSON.parse(savedState);
            const searchQuery = `/search?q=${state.searchText}&skip=${state.searchSkip}&sort=${state.sortingDesc}`;
        window.location.href = searchQuery;
        }
        else {
            window.location.href = "/search";
        }
    }
    

    private async downloadDocument(event: any) {        
        let results = await this._dataService.CallCheckIfBlobExists(this.state.fullFileName);

        if (results == true)
        {
            var FileSaver = require('file-saver');
            FileSaver.saveAs(this.state.fullFileName, this.state.fileName); 
        } 
        else
        {
            alert("This document has moved. Please contact your help desk.");
            let err: Error = new Error('(Document View) Download Document Error. Blob path unavailable');
        
            appInsights.trackException({
                exception: err
            });
            console.error(err);
        }           
    }

    private async getSearchDetails() {
        if (this.props.q !== null && this.props.q !== '') {
            let urlsplitted: IUrlVariables = this._helpers.UrlSpliting(this.props.q);

            await this.setState({
                searchText: urlsplitted.searchQuery || '',
                id: urlsplitted.id || ''
            });
        }
    }

    private async getApi(id: string) {
        try {
            let results: ISearch[] = await this._dataService.CallGetDocument(id);

            if (results.length > 0) {
                this.setState({ noAccess: false });

                let _date = DateTime.fromISO(results[0].contractDate).toFormat('dd LLLL yyyy');
                if (_date == 'Invalid DateTime') {
                    _date = 'Date unknown'
                }

                let _title: string = '';

                if (results[0].title.length > 0) {
                    results[0].title.map((t, i) => {
                        if (i > 0) {
                            _title += `, `;
                        }
                        _title += `${t}`;
                    });
                } else {
                    _title = 'Title unknown';
                }

                this.setState({
                    author: results[0].author,
                    title: _title,
                    titleArray: results[0].title,
                    division: results[0].division,
                    contractDate: _date,
                    agency: results[0].agency,
                    documentType: results[0].documentType,
                    securityGroup: results[0].securityGroup,
                    counterparties: results[0].counterparties,
                    counterparties2: results[0].counterparties2,
                    hOCRMetadata: results[0].hOCRMetadata,
                    fileName: results[0].fileName,
                    fullFileName: results[0].fullFileName
                });
            }
            else {
                this.setState({
                    noAccess: true,
                    error: false,
                    logged: true
                })
            }
        }
        catch (e) {
            if (this.state.logged) {
                this.setState({ error: true });
            }
        }
    }
}


export default DocumentView
